import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=7cb7d4ae&"
import script from "./forgot-password.vue?vue&type=script&lang=js&"
export * from "./forgot-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cb7d4ae')) {
      api.createRecord('7cb7d4ae', component.options)
    } else {
      api.reload('7cb7d4ae', component.options)
    }
    module.hot.accept("./forgot-password.vue?vue&type=template&id=7cb7d4ae&", function () {
      api.rerender('7cb7d4ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth/forgot-password.vue"
export default component.exports